<template>
  <div class="summary-metrics d-flex gap-5 justify-space-between">
    <div class="d-flex align-baseline flex-column gap-2">
      <span class="summary-metric__label">{{ actualLabel }}</span>
      <span class="summary-metric__value">{{ formattedActualAmount }}</span>
    </div>
    <div class="d-flex align-baseline flex-column gap-2">
      <span class="summary-metric__label">{{ compareLabel }}</span>
      <span class="summary-metric__value">{{ formattedCompareAmount }}</span>
    </div>
    <div class="d-flex align-baseline flex-column gap-2">
      <span class="summary-metric__label">Variance Amount</span>
      <span class="summary-metric__value">
        <span class="summary-metric__value" :class="varianceClass(varianceAmount)">{{ formattedVarianceAmount }}</span>
      </span>
    </div>
    <div class="d-flex align-baseline flex-column gap-2">
      <span class="summary-metric__label">Variance %</span>
      <span class="summary-metric__value">
        <span class="summary-metric__value" :class="varianceClass(varianceAmount)">{{ formattedVariancePercent }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SummaryMetrics',
  props: {
    actualLabel: String,
    compareLabel: String,
    actualAmount: [Number, String],
    compareAmount: [Number, String],
    varianceAmount: [Number, String],
    variancePercent: [Number, String],
    formatCurrency: Function,
    formatPercent: Function,
    varianceClass: Function,
  },
  computed: {
    formattedActualAmount() {
      return this.formatCurrency ? this.formatCurrency(this.actualAmount) : this.actualAmount;
    },
    formattedCompareAmount() {
      return this.formatCurrency ? this.formatCurrency(this.compareAmount) : this.compareAmount;
    },
    formattedVarianceAmount() {
      return this.formatCurrency ? this.formatCurrency(this.varianceAmount) : this.varianceAmount;
    },
    formattedVariancePercent() {
      return this.formatPercent ? this.formatPercent(this.variancePercent) : this.variancePercent;
    },
  },
};
</script>

<style scoped>
.summary-metrics {
  border-radius: var(--Space-xs, 8px);
  background: var(--Grey-50, #F7F7F7);
  padding: var(--space-4) var(--space-8);
}
.summary-metric__label {
  font-size: var(--font-size-xxs);
  color: var(--color-status-card-text);
  font-weight: 600;
}
.summary-metric__value {
  font-size: var(--font-size-xxs);
  font-weight: 600;
  color: #404047;
}
</style>
